module.exports = __webpack_public_path__ + "img/ocolus.17ccc757.png";